<div [attr.style]="iconStyle" (click)="clicked.emit()" class="icon" [ngClass]="iconClasses">
  <span [attr.style]="iconStyle" *ngFor="let path of paths" [ngClass]="path"></span>
</div>
